<div class="header-field">
  @if (type() === 'list') {
    <div class="header-field__form-field header-field__form-field--list">
      <mat-list>
        @for (option of options(); track option.value) {
          <mat-list-item
            class="header-field__list-item"
            (click)="onSelectItem(option.value)"
            [attr.data-testid]="'header-field-' + option.value"
          >
            {{ option.label }}
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
  @if (type() === 'select') {
    <mat-form-field class="header-field__form-field small-form-field" appearance="outline">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <mat-select [formControl]="control()" [attr.data-testid]="'header-field-' + label()">
        @for (option of options(); track option.value || $index) {
          <mat-option
            class="header-field__list-item"
            [value]="option.value"
            (click)="onSelectItem(option.value)"
            [attr.data-testid]="'header-field-' + option.value"
          >
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (type() === 'multi') {
    <div class="header-field__form-field header-field__form-field--list small-form-field">
      <mat-selection-list [formControl]="control()" (selectionChange)="onMultiChange()">
        @for (option of options(); track option.value) {
          <mat-list-option
            [value]="option.value"
            [attr.data-testid]="'header-field-' + option.value"
          >
            {{ option.label }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }
  @if (type() === 'autocomplete') {
    <mat-form-field class="header-field__form-field small-form-field" appearance="outline">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <input type="text" matInput [formControl]="inputFormControl" [matAutocomplete]="auto" />
      <mat-autocomplete
        class="header-field__autocomplete"
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="optionSelected($event)"
        [displayWith]="displayFn.bind(this)"
      >
        @for (option of options(); track option.value) {
          <mat-option [value]="option.value" [attr.data-testid]="'header-field-' + option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }
  @if (type() === 'chips') {
    <mat-form-field class="header-field__form-field textarea small-form-field" appearance="outline">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <mat-chip-grid class="header-field__chips-list" #chipList aria-label="Chips selection">
        <ng-container>
          @for (chipsOption of chipsOptions(); track chipsOption) {
            <mat-chip-row class="header-field__chip-item" (removed)="removeChip(chipsOption)">
              {{ chipsOption }}
              <button matChipRemove>
                <mat-icon class="header-field__chips-delete" color="warn">cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
          <input
            type="text"
            placeholder="Select"
            matInput
            #chipsInput
            [matChipInputFor]="chipList"
            [matAutocomplete]="auto"
          />
        </ng-container>
      </mat-chip-grid>
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="chipOptionSelected($event)"
        [displayWith]="displayFn.bind(this)"
      >
        @for (option of filteredOptions(); track option.value) {
          <mat-option
            class="header-field__chips"
            [value]="option.value"
            [attr.data-testid]="'header-field-' + option.value"
          >
            {{ option.label }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }
  @if (type() === 'radio') {
    <div class="header-field__form-field">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <mat-radio-group class="header-field__radio" [formControl]="control()">
        @for (option of options(); track option.value) {
          <mat-radio-button
            class="header-field__radio-option"
            [value]="option.value"
            (change)="radioOptionSelected($event)"
            [attr.data-testid]="'header-field-' + option.value"
          >
            {{ option.label }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
  @if (type() === 'number') {
    <mat-form-field class="header-field__form-field small-form-field" appearance="outline">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <input
        type="number"
        matInput
        [formControl]="control()"
        [max]="max()"
        [min]="min()"
        (change)="onNumberChange()"
        [attr.data-testid]="'header-field-' + label()"
      />
    </mat-form-field>
  }
  @if (type() === 'date') {
    <mat-form-field class="header-field__form-field small-form-field" appearance="outline">
      @if (label()) {
        <mat-label>{{ label() }}</mat-label>
      }
      <input
        matInput
        [matDatepicker]="startDatePicker"
        (dateChange)="onDateChanged($event)"
        [formControl]="control()"
        [min]="minDate()"
        [max]="maxDate()"
        [attr.data-testid]="'header-field-' + label()"
      />
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
  }
</div>
